import { format, isSameDay } from 'date-fns';
import { convertCustomDateFormatToISO } from '../../utils/commonUtils';

export function formatTimestamp(startDate = new Date(), endDate = new Date()) {
  let monthAbbreviated = '';
  let startDay = '';
  let startTime = '';
  let endTime = '';

  const start = new Date(startDate);
  const end = new Date(endDate);
  if (isNaN(start.getTime())) {
    return {
      monthAbbreviated,
      startDay,
      startTime,
      endTime,
    };
  }

  const month = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(
    start,
  );
  monthAbbreviated = month.slice(0, 3);
  startDay = start.getDate();

  startTime = format(start, 'p');
  endTime = format(end, 'p');

  if (!isSameDay(start, end)) {
    // startTime = `${monthAbbreviated} ${start.getDate()}, ${startTime}`;

    const endMonth = new Intl.DateTimeFormat('en-IN', { month: 'long' }).format(end);
    const endMonthAbbreviated = endMonth.slice(0, 3);
    endTime = `${endMonthAbbreviated} ${end.getDate()}, ${endTime}`;
    startTime = `${monthAbbreviated} ${startDay}, ${startTime}`;
  }

  return {
    monthAbbreviated,
    startDay,
    startTime,
    endTime,
  };
}

export function formatTimestampWithStartDate(startDate = new Date(), endDate = new Date()) {
  let monthAbbreviated = '';
  let startDay = '';
  let startTime = '';
  let endTime = '';

  const start = new Date(startDate);
  const end = new Date(endDate);
  if (isNaN(start.getTime())) {
    return {
      monthAbbreviated,
      startDay,
      startTime,
      endTime,
    };
  }

  const month = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(
    start,
  );
  monthAbbreviated = month.slice(0, 3);
  startDay = start.getDate();

  startTime = format(start, 'p');
  endTime = format(end, 'p');
  startTime = `${monthAbbreviated} ${start.getDate()}, ${startTime}`;

  if (!isSameDay(start, end)) {
    const endMonth = new Intl.DateTimeFormat('en-IN', { month: 'long' }).format(end);
    const endMonthAbbreviated = endMonth.slice(0, 3);
    endTime = `${endMonthAbbreviated} ${end.getDate()}, ${endTime}`;
  }

  return {
    monthAbbreviated,
    startDay,
    startTime,
    endTime,
  };
}

export const getMenuItems = (status) => {
  switch (status) {
  case 'live':
    return [
      // { id: 'Edit', label: 'Edit' },
      // { id: 'View event', label: 'View event' },
    ];
  case 'draft':
    return [
      { id: 'Edit', label: 'Edit' },
      { id: 'Delete', label: 'Delete' },
    ];
  case 'upcoming':
    return [
      { id: 'Edit', label: 'Edit' },
      // { id: 'View event', label: 'View event' },
      { id: 'Delete', label: 'Delete' },
    ];

  default:
    return [];
  }
};
